import React from "react";
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Hidden from "@material-ui/core/Hidden";
import Poppers from "@material-ui/core/Popper";
// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Notifications from "@material-ui/icons/Notifications";
import Search from "@material-ui/icons/Search";
// core components
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import SettingsEditor from "components/SettingsEditor/SettingsEditor.jsx";

// redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SearchUsers, SearchResults, ClearSearch } from 'redux/actions';

// firebase
import { db } from 'assets/firebase';

// routing
import { withRouter } from 'react-router-dom';

import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle";

class HeaderLinks extends React.Component {
  state = {
    open: false,
    searchQuery: ''
  };
  
  handleToggle = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };

  handleSearchChange = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  handleSearch = () => {
    const { searchQuery } = this.state;
    const { location } = this.props;
    
    // Only search if on the staff page and query is not empty
    if (location.pathname === '/staff' && searchQuery.trim()) {
      // Dispatch search action (sets loading to true)
      this.props.onSearchUsers(searchQuery);
      
      // Call the search API
      db.searchUsers(searchQuery)
        .then(results => {
          this.props.onSearchResults(results);
        })
        .catch(error => {
          console.error('Search failed:', error);
          // Even on error, we need to stop loading
          this.props.onSearchResults([]);
        });
    }
  };

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.handleSearch();
    }
  };

  render() {
    const { classes, location } = this.props;
    const { open, searchQuery } = this.state;
    
    // Only show search on staff page
    const showSearch = location.pathname === '/staff';
    
    return (
      <div>
        {showSearch && (
          <div className={classes.searchWrapper} style={{display:"inline-block"}}>
            <CustomInput
              formControlProps={{
                className: classes.margin + " " + classes.search
              }}
              inputProps={{
                placeholder: "Search users by email or name",
                value: searchQuery,
                onChange: this.handleSearchChange,
                onKeyPress: this.handleKeyPress,
                inputProps: {
                  "aria-label": "Search"
                }
              }}
            />
            <Button 
              color="white" 
              aria-label="search" 
              justIcon 
              round
              onClick={this.handleSearch}
            >
              <Search />
            </Button>
          </div>
        )}
        {/*
        <div className={classes.manager}>
          <Button
            buttonRef={node => {
              this.anchorEl = node;
            }}
            color={window.innerWidth > 959 ? "transparent" : "white"}
            justIcon={window.innerWidth > 959}
            simple={!(window.innerWidth > 959)}
            aria-owns={open ? "menu-list-grow" : null}
            aria-haspopup="true"
            onClick={this.handleToggle}
            className={classes.buttonLink}
          >
            <Notifications className={classes.icons} />
            <span className={classes.notifications}>5</span>
            <Hidden mdUp implementation="css">
              <p onClick={this.handleClick} className={classes.linkText}>
                Notification
              </p>
            </Hidden>
          </Button>
          <Poppers
            open={open}
            anchorEl={this.anchorEl}
            transition
            disablePortal
            className={
              classNames({ [classes.popperClose]: !open }) +
              " " +
              classes.pooperNav
            }
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="menu-list-grow"
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom"
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <MenuList role="menu">
                      <MenuItem
                        onClick={this.handleClose}
                        className={classes.dropdownItem}
                      >
                        Hello
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Poppers>
          
        </div>
        */}
        <Button
          color={window.innerWidth > 959 ? "transparent" : "white"}
          justIcon={window.innerWidth > 959}
          simple={!(window.innerWidth > 959)}
          aria-label="Person"
          className={classes.buttonLink}
        >
          <Person className={classes.icons} />
          <Hidden mdUp implementation="css">
            <p className={classes.linkText}>Profile</p>
          </Hidden>
        </Button>
        <div style={{display:"inline-block"}}>
          <SettingsEditor />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onSearchUsers: SearchUsers,
    onSearchResults: SearchResults,
    onClearSearch: ClearSearch
  }, dispatch);  
}

HeaderLinks = connect(mapStateToProps, mapDispatchToProps)(HeaderLinks);
HeaderLinks = withRouter(HeaderLinks);
export default withStyles(headerLinksStyle)(HeaderLinks);


// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx